// components/About.js
import React from 'react';
import './About.css';
import heroImage from "../assets/IMG-20250924-WA0011.webp";

const About = () => {
  return (
    <section className="about" id="about">
      <div className="container">
        <div className="about-header">
          <h2>A Group For the South Sound  Community</h2>
   
        </div>
        
        <div className="about-content">
          <div className="about-image">
            <div className="image-container">
              <img 
                src={heroImage}
              />
              <div className="image-overlay"></div>
            </div>
          </div>
          
          <div className="about-text">
            <div className="text-container">
              <p>
               Renewed Life Networking Group was founded on the shared values of business owners across Pierce County and beyond. We believe that businesses should be able to share their most meaningful challenges, victories, and visions with others who understand the journey, and we wanted to develop a network of professionals who are open to authentic discussions about their own experiences, trials and successes.
              </p>
              
              <p>
              That is why we created this group, a place where small business owners can connect, exchange ideas, and discuss what matters most to them in a respectful and supportive environment. 
              </p>

            </div>
            
          
           
              
         
              
            
       
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
